<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <!-- <AlertPopup :importData="importData"/> -->
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <settings-tabs></settings-tabs>
          <!-- /Settings Menu -->

          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <!-- Prefixes -->
              <div class="card">
                <div class="card-body settings-form">
                  <div class="settings-header">
                    <website-sidebar :file_id="file_id" :show_assign_data="show_assign_data"></website-sidebar>
                  </div>
                  <Form ref="assignForm" @submit="handleSubmit" :validation-schema="schema" v-slot="{ field, errors }"
                    v-if="Object.keys(assignedData).length > 0">
                    <div class="row align-items-center py-2">
                      <div class="col"></div>
                      <div class="col-md-7">
                        <div class="row mb-4">
                          <div class="col-md-4">
                            <h5 class="text-teal"><span>Total Rows:</span> <span>{{ assignedData.total_rows }}</span>
                            </h5>
                          </div>
                          <div class="col-md-4 text-center">
                            <h5 class="text-danger"><span>Unassigned Rows: </span> <span>{{ assignedData.total_rows -
                              assignedData.assgined_rows_count }}</span></h5>
                          </div>
                          <div class="col-md-4 text-end">
                            <h5 class="text-success"><span>Assigned Rows: </span> <span>{{
                              assignedData.assgined_rows_count }}</span></h5>
                          </div>
                        </div>
                        <div v-for="(row, index) in rows" :key="index" class="row position-relative">
                          <div class="col-md-3 mb-2 mb-md-0">
                            <label class="col-form-label">Start</label>
                            <Field :name="'rows[' + index + '].start'" as="input" type="number" class="form-control"
                              v-model="row.start" />
                            <ErrorMessage :name="'rows[' + index + '].start'" class="text-danger" />
                            <span class="text-danger">{{ errors?.[`rows[${index}]`] }}</span>
                          </div>
                          <div class="col-md-3 mb-2 mb-md-0">
                            <label class="col-form-label">End</label>
                            <Field :name="'rows[' + index + '].end'" as="input" type="number" class="form-control"
                              v-model="row.end" />
                            <ErrorMessage :name="'rows[' + index + '].end'" class="text-danger" />
                            <span class="text-danger">{{ errors?.[`rows[${index}]`] }}</span>
                          </div>
                          <div class="col-md-3 mb-2 mb-md-0">
                            <div class="form-wrap mb-0 ">
                              <label class="col-form-label">Territory</label>
                              <Field as="select" :name="'rows[' + index + '].territory_id'" class="form-select"
                                v-model="row.territory_id" @change="handleTerritoryChange(index)">
                                <option value="">-----Select-----</option>
                                <option v-for="ter in Territories" :key="ter.id" :value="ter.id">{{ ter.name }}</option>
                              </Field>
                              <ErrorMessage :name="'rows[' + index + '].territory_id'" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-md-3 mb-2 mb-md-0">
                            <div class="form-wrap">
                              <label class="col-form-label">Responsible</label>
                              <Field as="select" :name="'rows[' + index + '].responsible'" class="form-select"
                                v-model="row.responsible">
                                <option value="">-----None-----</option>
                                <option v-for="res in row.responsibles" :key="res.id" :value="res.id">{{ res.name }}
                                </option>
                              </Field>
                              <ErrorMessage :name="'rows[' + index + '].responsible'" class="text-danger" />
                            </div>
                          </div>

                          <!-- Conditional Delete Button for all rows except the first -->
                          <div class="mt-2 position-absolute delete_row" v-if="index > 0">
                            <a href="#" @click="deleteRow(index)"><i class="ion-close-round text-danger"
                                data-bs-toggle="tooltip" title="Delete Row"></i></a>
                            <!-- <button type="button" class="btn btn-danger" @click="deleteRow(index)">Delete Row</button> -->
                          </div>
                        </div>

                        <!-- Button to Add New Row -->
                        <div class="row align-items-center">
                          <div class="col-md-8">
                            <div v-if="fileWarn > 0">
                              <p class="mb-0">Some records contain errors. Please review the following issues. <a
                                  :href="getErrorLogLink(file_id)" target="_blank" class="text-teal fw-bold">
                                  View details
                                </a></p>
                              <!-- <h6>{{ fileWarn }} Warnings</h6> -->
                            </div>
                          </div>
                          <div class="col-md-4 text-end">
                            <button @click="addNewRow" type="button" class="btn btn-primary">Add Row</button>
                          </div>
                        </div>
                      </div>
                      <div class="col"></div>
                    </div>

                    <!-- Submit Button -->
                    <div class="submit-button">
                      <div class="row">
                        <div class="col-md-6">
                          <!-- <button type="submit" class="btn btn-primary">Save Changes</button> -->
                        </div>
                        <!-- <div class="col-md-6 text-end" v-if="isMapped">
                        <button type="submit" class="btn btn-teal">Begin Import</button>
                      </div> -->

                        <div class="col-md-6 text-end">
                          <button type="submit" class="btn btn-teal" :disabled="!isMapped || isMessage.status || isImport"
                            :style="{ cursor: !isMapped || isMessage.status || isImport ? 'not-allowed' : 'pointer', opacity: !isMapped || isMessage.status || isImport ? 0.5 : 1 }">
                            Begin Import
                          </button>
                        </div>

                      </div>
                    </div>
                  </Form>
                  <div class="row" v-else>
                    <div class="col"></div>
                    <div class="col-md-7 py-3 bg-light">
                      <p class="text-center "><i class="ion-information-circled"></i> Please upload and map a file</p>
                    </div>
                    <div class="col"></div>
                  </div>
                </div>
                <div class="row align-items-center py-4 border-top" v-if="Object.keys(assignedData).length > 0">
                  <div class="col"></div>
                  <div class="col-md-7">
                    <h4>Assigned Data</h4>
                    <table class="table">
                      <thead>
                        <tr>
                          <!-- <th>Entry</th> -->
                          <th class="text-center">Start</th>
                          <th class="text-center">End</th>
                          <th class="text-center">Territory</th>
                          <th class="text-center">Responsible</th>
                          <!-- <th>Batch Number</th> -->
                        </tr>
                      </thead>
                      <tbody
                        v-if="(Object.keys(assignedData.assigned_data).length > 0) || (assignedData.assigned_data.length > 0)">
                        <tr v-for="(data, index) in assignedData.assigned_data" :key="index">
                          <!-- <td>{{ index }}</td> -->
                          <td class="text-center">{{ data.start }}</td>
                          <td class="text-center">{{ data.end }}</td>
                          <td class="text-center">{{ data.territory !== "" ? data.territory : 'Not Assigned' }}</td>
                          <td class="text-center">{{ data.responsible !== "" ? data.responsible : 'Not Assigned' }}</td>
                          <!-- <td>{{ data.batch_number }}</td> -->
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="5" class="text-center"><i class="ion-information-circled"></i> No data found</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col"></div>
                </div>
              </div>
              <!-- /Prefixes -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  watch,
  computed
} from "vue";
import {
  useStore
} from "vuex";
import {
  useRoute,
  useRouter
} from "vue-router";
import {
  Form,
  ErrorMessage,
  Field
} from "vee-validate";
import * as Yup from "yup";
import { onImportCompleted, onImportProgress } from '@/socket';
import AlertPopup from '@/views/layouts/AlertPopup.vue';

export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    AlertPopup
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const isMapped = ref(false);
    const fileWarn = ref(null);
    const importData = ref({})
    const isImport = ref(false);
    const show_assign_data = ref(route.query.showAssignData || "true")
    const file_id = ref(route.query.fileId || localStorage.getItem('fileId') || null);
    // Reactive state
    const rows = ref([{
      territory_id: '',
      responsible: '',
      start: '',
      end: '',
      responsibles: []
    }]);

    const isMessage = computed(() => store.state.importMessage);

    const Territories = computed(() => store.getters['organisation/getTerritories']);
    // Validation schema using yup
    // const schema = Yup.object().shape({
    //   rows: Yup.array().of(
    //     Yup.object().shape({
    //       start: Yup.string().required('Start is required'),
    //       end: Yup.string().required('End is required'),
    //       territory_id: Yup.string().required('Territory is required'),
    //       responsible: Yup.string().required('Responsible is required'),
    //     })
    //   ),
    // });

    // const schema = Yup.object().shape({
    //   rows: Yup.array().of(
    //     Yup.object().shape({
    //       start: Yup.number()
    //         .required('Start is required')
    //         .typeError('Start must be a number'),
    //       end: Yup.number()
    //         .required('End is required')
    //         .typeError('End must be a number'),
    //       territory_id: Yup.string().required('Territory is required'),
    //       responsible: Yup.string().required('Responsible is required'),
    //     }).test(
    //       'start-end-difference',
    //       'The difference between Start and End should not be greater than 1000',
    //       function (value) {
    //         const { start, end } = value || {};
    //         if (isNaN(start) || isNaN(end)) {
    //           return true;
    //         }
    //         return Math.abs(end - start) <= 999;
    //       }
    //     )
    //   ),
    // });

    const assignedData = ref({});
    const assignForm = ref(null); // for template ref

    const schema = computed(() => {
      const data = assignedData.value;
      const isPersonOnly = data?.modules?.length === 1 && data.modules[0] === 'person';
      return Yup.object().shape({
        rows: Yup.array().of(
          Yup.object().shape({
            // start: Yup.number()
            //   .required('Start is required')
            //   .typeError('Start must be a number'),
            // end: Yup.number()
            //   .required('End is required')
            //   .typeError('End must be a number'),
            start: Yup.number()
              .required('Start is required')
              .typeError('Start must be a number')
              .test('start-less-than-end', 'Start number must be less than End number', function (value) {
                const { end } = this.parent;
                return value <= end;
              })
              .test('range-overlap', 'Invalid range: the start and end values are already assigned.', function (value) {
                const { end } = this.parent;
                if (value !== undefined && end !== undefined) {
                  return !isRangeOverlapping(value, end);
                }
                return true;
              }),

            end: Yup.number()
              .required('End is required')
              .typeError('End must be a number')
              .test('end-greater-than-start', 'End number must be greater than Start number', function (value) {
                const { start } = this.parent;
                return value >= start;
              }),
            territory_id: Yup.string().when([], {
              is: () => !isPersonOnly,
              then: (schema) => schema.required('Territory is required'),
              otherwise: (schema) => schema.notRequired(),
            }),
            responsible: Yup.string().when([], {
              is: () => !isPersonOnly,
              then: (schema) => schema.required('Responsible is required'),
              otherwise: (schema) => schema.notRequired(),
            }),
          }).test(
            'start-end-difference',
            'The difference between Start and End should not be greater than 1000',
            function (value) {
              const { start, end } = value || {};
              if (isNaN(start) || isNaN(end)) {
                return true;
              }
              return Math.abs(end - start) <= 999;
            }
          )
        )
          .test('no-overlap', 'Ranges must not overlap.', function (rows = []) {
            const seen = [];

            for (let i = 0; i < rows.length; i++) {
              const { start, end } = rows[i];
              if (start === undefined || end === undefined) continue;

              for (const [s, e] of seen) {
                const overlap = Math.max(s, start) <= Math.min(e, end);
                if (overlap) {
                  return this.createError({
                    path: `rows[${i}].start`,
                    message: `Overlapping range with another entry.`,
                  });
                }
              }

              seen.push([start, end]);
            }

            return true;
          })
      });
    });

    // Utility to check overlap
    const isRangeOverlapping = (newStart, newEnd) => {
      return assignedData.value.assigned_data.some(({ start, end }) => {
        return !(newEnd < start || newStart > end);
      });
    };


    const fetchAssignedData = async (id) => {
      const data = await store.dispatch("dataimport/getAssignedData", id);
      assignedData.value = data;
      if ((data.total_rows - data.assgined_rows_count === 0) && (fileWarn.value === 0)) {
        router.push({
          path: '/data-import/import-data-status',
          query: { showAssignData: show_assign_data }
        });
        isMapped.value = false;
      } else {
        isMapped.value = data.has_mapping
      }
    };

    const getErrorLogLink = (file_id) => {
      return router.resolve({ path: '/data-import/error-logs', query: { fileId: file_id } }).href;
    };
    // Fetch territories on mount
    onMounted(async () => {
      // onImportCompleted(async (importDataValue) => {
      //   isImport.value = false;
      //   assignForm.value?.resetForm();
      //   await store.dispatch('importMessage', { status: false, message: importDataValue })
      //   localStorage.setItem('import', JSON.stringify({ status: false, message: importDataValue }))
      //   importData.value = importDataValue;
      // });

      // onImportProgress(async (progress) => {
      //   await store.dispatch('importMessage', { status: true, message: null, progress: progress })
      //   localStorage.setItem('import', JSON.stringify({ status: true, message: null, progress: progress }))
      // });

      if (file_id.value) {
        await fetchAssignedData(file_id.value)
        // store.dispatch('dataimport/getAssignedData', file_id.value);
      }
      store.dispatch('organisation/fetchTerritories');
    });

    // Handle the territory change
    const handleTerritoryChange = async (index) => {
      const selectedTerritoryId = rows.value[index].territory_id;
      if (selectedTerritoryId) {
        try {
          // Fetch the responsible users for the selected territory
          const response = await store.dispatch('organisation/fetchTerritoryCompanyUsers', [selectedTerritoryId]);
          // Only update the responsibles for the current row
          rows.value[index].responsibles = response || [];
          rows.value[index].responsible = ''; // Reset responsible selection
        } catch (error) {
          console.error("Error fetching responsibles:", error);
        }
      }
    };

    // Method to add a new row
    const addNewRow = () => {
      rows.value.push({
        territory_id: '',
        responsible: '',
        start: '',
        end: '',
        responsibles: []
      });
    };

    const handleSubmit = async () => {
      // Build the payload
      const assignData = rows.value.map((row) => ({
        start: row.start,
        end: row.end,
        territory: row.territory_id,
        responsible: row.responsible,
      }));
      // Dispatch API call with payload
      const data = await store.dispatch('dataimport/beginImportData', {
        file_id: file_id.value,
        assign_data: assignData,
      });
      if (data?.data?.status) {
        isImport.value = true;
        // await store.dispatch('importMessage', { status: true, message: null })
        // localStorage.setItem('import', JSON.stringify({ status: true, message: null }))
        fileWarn.value = data.data.data.warning_count;
        //   fetchAssignedData(file_id.value);
      }
    };

    // Method to delete a row (except the first row)
    const deleteRow = (index) => {
      rows.value.splice(index, 1); // Removes the row at the given index
    };

    watch(importData, () => {
      if (importData.value && importData.value.file_id) {
        fetchAssignedData(file_id.value);
      }
    },
      { immediate: true }
    );

    watch(
      isMessage,
      (newVal) => {
        if (!newVal.status) {
          isImport.value = false;
          assignForm.value?.resetForm();
          importData.value = newVal.message;
        }
      },
      {
        immediate: true,
        deep: true, // Important if importMessage is an object
      }
    );

    return {
      getErrorLogLink,
      isMapped,
      handleSubmit,
      schema,
      handleTerritoryChange,
      fetchAssignedData,
      file_id,
      Territories,
      rows,
      fileWarn,
      importData,
      addNewRow,
      deleteRow,
      // beginImport,
      assignedData,
      show_assign_data,
      isImport,
      assignForm,
      isMessage
    }
  }
}
</script>

<style lang="scss" scoped>
.delete_row {
  right: -30px;
  top: 25px;
  width: 25px;
  height: 25px;
  border: 1px solid red;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    margin-left: 1px;
  }
}
</style>
